import { render } from "./ReportsView.vue?vue&type=template&id=21b12d4c&ts=true"
import script from "./ReportsView.vue?vue&type=script&lang=ts"
export * from "./ReportsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__